import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { AssetCheckList } from "./checklist.entity";


@Injectable()
@EntityRepository(AssetCheckList)
export class AssetCheckListRepository extends Repository<AssetCheckList>{
    
}